<template>
  <warehousing-in-stack lob="SE" />
</template>

<script>
import WarehousingInStack from '@/components/Cargo/Warehouse/warehousingInStack'
export default {
  name: 'SEWarehousing',
  components: { WarehousingInStack }
}
</script>

<style scoped>

</style>
